<template>
  <section v-show="isVisible" :id class="toggle-container">
    <BlokkliField
      v-slot="{ items }"
      name="field_paragraphs"
      :list="paragraphs"
      :should-render-item
      drop-alignment="vertical"
      class="container min-h-24 !space-y-spacing-lg"
    >
      <div
        v-for="item in filterNullArray(items)"
        :key="item.uuid"
        :class="{
          container: item?.bundle !== 'teaser_list',
          '!mt-spacing-base belowTablet:px-section-x':
            item?.bundle === 'teaser_list',
        }"
      />
    </BlokkliField>
  </section>
</template>

<script lang="ts" setup>
import type { ParagraphToggleContainerFragment } from '#graphql-operations'
import { filterNullArray } from '~/helpers'

withDefaults(
  defineProps<{
    paragraphs?: ParagraphToggleContainerFragment['paragraphs']
  }>(),
  {
    paragraphs: () => [],
  },
)

const { index, siblings, options, rootBlocks } = defineBlokkli({
  bundle: 'toggle_container',
  globalOptions: ['contextToggleId', 'bkHiddenGlobally', 'publicationChannels'],
  editor: {
    determineVisibleOptions: function () {
      return ['contextToggleId', 'bkHiddenGlobally', 'publicationChannels']
    },
  },
  propsFieldMapping: {
    id: { type: 'editable', name: 'id' },
    paragraphs: { type: 'field', name: 'field_paragraphs' },
  },
})

const id = useParagraphAnchorId(index, siblings)
const { shouldRenderItem } = useParagraphVisiblity()
const { determineVisibility } = usePartyToggle()
const isVisible = determineVisibility(options, rootBlocks)
</script>

<style lang="postcss">
.toggle-container .container {
  .paragraph-text + .paragraph-teaser-list,
  .paragraph-title + .paragraph-teaser-list {
    @apply !mt-spacing-base;
  }
}
</style>
